/**
 * Sheet: a Dialog that slides in from a screen edge. shadcn `Sheet` parity.
 *
 * Behaviour is exactly Dialog's (focus trap and return, Escape, overlay click,
 * scroll lock, inert beneath, exit presence); the only addition is
 * `data-side` on the content, read by CSS to pick the edge and the slide
 * direction. `side` comes from the option, else from markup, else `right`.
 *
 * @markup sheet div style="display: contents" data-state=open|closed
 * @markup sheet-trigger button type=button aria-haspopup=dialog aria-expanded aria-controls data-state=open|closed
 * @markup sheet-overlay div hidden data-state=open|closed
 * @markup sheet-content div role=dialog hidden aria-modal aria-labelledby aria-describedby data-state=open|closed data-side=top|right|bottom|left tabindex=-1
 * @markup sheet-title h2 id
 * @markup sheet-description p id
 * @markup sheet-close button type=button
 */
import { createDialog } from './_dialog-core.js';
export function attachSheet(root, options = {}) {
    const core = createDialog(root, options, { name: 'sheet', role: 'dialog' });
    const content = core.parts?.content ?? null;
    const setSide = (side) => content?.setAttribute('data-side', side);
    if (options.side)
        setSide(options.side);
    else if (content && !content.hasAttribute('data-side'))
        setSide('right');
    return {
        open: core.open,
        close: core.close,
        toggle: core.toggle,
        setOpen: core.setOpen,
        destroy: core.destroy,
        get isOpen() {
            return core.isOpen;
        },
        setSide,
    };
}
